import { useLocation, useNavigate } from "react-router-dom";
import { ScanLine } from "lucide-react";

/**
 * ScanFab -- Floating Action Button für Mobile-Shell.
 * Platzierung: unten rechts über der Bottom-Nav (bottom-24, right-4).
 * Daumen-erreichbar bei Einhand-Bedienung.
 *
 * Versteckt sich auf /scan (wäre redundant) und in Buchungsflows. Dort ist
 * die Sticky-Aktion die einzige Primäraktion und der Scanner Teil des Flows.
 */
export function ScanFab() {
    const location = useLocation();
    const navigate = useNavigate();
    if (location.pathname.startsWith("/scan") || location.pathname.startsWith("/flows/")) return null;

    return (
        <button
            type="button"
            onClick={() => navigate("/scan")}
            className="pw-tap fixed bottom-24 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-2xl transition-transform active:scale-95 hover:bg-primary/90"
            aria-label="Scanner schnell öffnen"
            data-testid="scan-fab"
        >
            <ScanLine className="h-6 w-6" strokeWidth={2.4} />
        </button>
    );
}
